import * as isValid from 'state/customize/selectors/isValid' 

export function validateFinishVM(state, vm){
  const parts = {
    finish : (vm.selected && vm.selected.type !== 'restorationType') ? 
      isValid.validObj :
      isValid.finish(state, vm.finish),
  } 
  const combinedValidation = isValid.combineValidation(...Object.keys(parts).map(k => parts[k]));
  return Object.assign({ parts }, combinedValidation);
}
export function validateBackFaceVM(state, vm, isConfirmation){
  const parts = {
    //if paintFill is not set to 7 (keep as is) then pass false for enable validate paintFill locations
    paintFillLocations : { valid: true, errors: [] },
    initials : isValid.combineValidation(...vm.initials.map((loc) => isValid.initials(state, loc, isConfirmation))),
    stampsLocations : isValid.combineValidation(...vm.stampsLocations.map((loc) => isValid.stamp(state, loc, isConfirmation)))
  } 
  
  if(isConfirmation) {
	parts.paintFillLocations = isValid.combineValidation(...vm.paintFillLocations.map((loc) => isValid.paint(state, loc, state.instance.paintFill !== 7)));
  }
  
  const combinedValidation = isValid.combineValidation(...Object.keys(parts).map(k => parts[k]));
  return Object.assign({ parts }, combinedValidation);
}

export function validateTopVM(state, vm, isConfirmation){
  const parts = {
    flangeLines : isValid.line(state, vm.flangeLines, null, isConfirmation),
    topLines : isValid.line(state, vm.topLines, vm.sightDots, isConfirmation),
    sightDots : isValid.line(state, vm.sightDots, vm.topLines, isConfirmation),
    paintFillLocations : { valid: true, errors: [] },
	//if paintFill is not set to 7 (keep as is) then pass false for enable validate paintFill locations
    //paintFillLocations : isValid.combineValidation(...vm.paintFillLocations.map((loc) => isValid.paint(state, loc, state.instance.paintFill !== 7))),
  } 
  
  if(isConfirmation) {
	parts.paintFillLocations = isValid.combineValidation(...vm.paintFillLocations.map((loc) => isValid.paint(state, loc, state.instance.paintFill !== 7)));
  }
  
  const combinedValidation = isValid.combineValidation(...Object.keys(parts).map(k => parts[k]));
  return Object.assign({ parts }, combinedValidation);
}

export function validateSpecsVM(state, vm){
  const parts = {
    weight : isValid.weight(state, vm.weight),
    topWeight : vm.hasTopWeights ? isValid.weight(state, vm.topWeight) : isValid.validObj,
    reshaft: isValid.reshaft(state, vm),
    length: isValid.length(state, vm),
	reshaftLength: isValid.reshaftLength(state, vm),
    lie: isValid.lie(state, vm),
    loft: isValid.loft(state, vm)
  } 
  
  const combinedValidation = isValid.combineValidation(...Object.keys(parts).map(k => parts[k]));
  return Object.assign({ parts }, combinedValidation);
}

export function validateAuthenticationVM(state, vm){
  const parts = {
    authentication : isValid.authentication(state, vm),
  } 
  const combinedValidation = isValid.combineValidation(...Object.keys(parts).map(k => parts[k]));
  return Object.assign({ parts }, combinedValidation);
}

export function validateAccessoriesVM(state, vm){
  const parts = {
    grip : isValid.grip(state, vm),
    shaftBand : isValid.shaftBand(state, vm),
    headCover : isValid.headCover(state, vm),
    buyAPutter : isValid.buyAPutter(state, vm)
  } 
  const combinedValidation = isValid.combineValidation(...Object.keys(parts).map(k => parts[k]));
  return Object.assign({ parts }, combinedValidation);
}